<template>
   <vue-final-modal
      v-model="v310Modal" 
      @click-outside="beforeClose()"
      @before-open="beforeOpen()"
      @opened="opened()"
      classes="modal-container"
      content-class="v310-modal-content"
      drag-selector=".drug-area"
      :drag="true"
      :click-to-close="false"
      >
      <!--
      @click-outside="$emit('cancel')"
            @click="$emit('cancel')"
       -->
      <div class="drug-area">
      <button 
            id="last"
            type="button"
            class="modal__close btn btn-sm" 
            :tabindex="currentLastTabIndex + 4" 
            @click="beforeClose()"
            >
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg tx-cl-white" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
         </svg>
      </button>
      <span class="modal__title tx-cl-white">Voucher <i class="fs-14">(Resol. SSS 310/04)</i></span>
      </div>
      <!-- 
      <div class="up-voucher rounded-2 border p-2">
      -->
      <div class="up-voucher border-top p-1 mt-1">
         <div class="container">
            <Form
               @submit="nextStep"
               :validation-schema="currentSchema"
               keep-values
               v-slot="{ values }"
               :initial-values="dataVoucher"
               >
               
               <div tabindex="1" onfocus="document.getElementById('last').focus()"></div>
               <!-- first data affiliate,... -->
               <!--
                  <div class=" row border-top mt-0"></div>
               -->
               <template v-if="currentStep === 0">
                  
                  <div class="row justify-content-between">
                     <div class=" col-12 col-md-5 p-0 m-0">
                        <special-button-field 
                              :fieldData="v310Cnf.cuil" 
                              :tabindex="2" 
                              :id="'first'"
                              :newValue="newCuilValue"
                              :changeValue="changeValue"
                              @onButtonClick="searchAffil = true"
                              @onBlur="onBlurCuit = true" 
                              @onFocus="onBlurCuit = false" 
                              >
                           <font-awesome-icon icon="search" class="tx-cl-white"/> 
                        </special-button-field>
                        <!-- 
                              :resetButton="'resetCuil'"
                        -->
                     </div>

                     <div v-if="validCuil" class="col-12 col-md-7 row justify-content-between m-0 pe-0">
                        <div class="col-1 text-center p-2">
                        <button type="button" 
                              :tabindex="3" 
                              class="btn btn-outline-light btn-sm"
                              title="Historial"
                              @click="affilHistory( values.cuil )"
                              >
                           <b>H</b>
                        </button>
                        </div>
                        <div v-if=" annulComplValues.annulCompl > 0 " class="col-10 px-0">
                           <div class="row mx-0">
                              <div v-if=" annulComplValues.annulCompl == 1 " class="col-11 px-0">Anula Autorización Nro:</div>
                              <div v-else class="col-11 px-0">Complementa Autorización Nro:</div>
                              <div class="col-1 px-0 text-center hover-click" 
                                 @click=" annulComplValues.annulCompl = 0 ">
                                 X
                              </div>
                           </div>
                           <div class="border rounded ps-1 pb-1">
                              <b>{{ annulComplValues.id }}</b>
                           </div>
                        </div>
                     </div>
                     <div v-else class="col-12 col-md-7 m-0 p-0">
                     </div>

                     <affiliate-data v-if="validCuil"
                        :dataAffiliate="dataAffil" 
                        class="col-12 rounded border mt-1"
                        />
                        <!--
                        -->

                     <div class=" col-12 col-md-6 p-0 m-0">
                        <common-field 
                           :fieldData="v310Cnf.requestDate" 
                           :tabindex="4"
                           :readonly="readonly"
                           />
                     </div>
                     <div v-if=" oDataFromCard.cardId == 0 " class=" col-12 col-md-5 p-0 m-0">
                        <common-field :fieldData="v310Cnf.tramitNumber" :tabindex="5"/>
                     </div>
                     <div v-else class=" col-12 col-md-5 p-0 m-0">
                        ID Tarjeta: <br>
                        <div class="border rounded ps-1 pb-1">
                           <b>{{ oDataFromCard.cardId }}</b>
                        </div>
                     </div>
                     
                     <div class=" col-12 col-md-5 p-0 m-0">
                        <common-field :fieldData="v310Cnf.phone" :tabindex="6"/>
                     </div>
                     <div class=" col-12 col-md-6 p-0 m-0">
                        <select-field :fieldData="v310Cnf.specialty" :tabindex="7" :options="specialtys"/>
                     </div>
                     
                  </div>

                  <!-- 
                  -->
                  <!-- -->
                  <!--
                     {{dataAffil}}
                 -->
               </template>

               <!-- second data prescription drugs,... -->
               <template v-if=" currentStep === 1 ">
                  <div class="row">
                     <label for="drugs" class="classLabel col-10 px-0 pt-1"> Monodrogas Prescriptas </label>
                     <button 
                        type="button" 
                        class="btn btn-sm col-2 order-md-last p-0 text-end pe-2" 
                        :tabindex="2" :id="'first'"
                        @click="upWizardDrugs = true"
                        >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg tx-cl-white" viewBox="0 0 16 16">
                           <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                        </svg>
                     </button>
                     <!--
                     -->
                  </div>
                  <div class="row border rounded mt-1 mb-2 p-1">
                     <table class="table table-sm table-borderless mb-0">
                        <tbody>
                           <tr v-for="(item, index) in prescribedDrugs" :key="index"
                                 class="tr-drugs"
                                 >
                              <td class="border py-0 table-light">{{item.disease.name.trim()}}</td>
                              <td class="border py-0 bg-contrast text-end">{{item.disease.pathologyId}}</td>
                              <td class="border py-0 table-light text-end">{{item.disease.diseaseId}}</td>
                              <td class="border p-0 table-light">
                                 <div class="row m-0 pe-1">
                                    <div v-for="(monodrug, index) in item.drugs" :key="index"
                                       class="rounded border-contrast col-auto row ms-1 me-0 p-0 pill">
                                       <div class="col-auto px-1 bg-contrast" :title='monodrug.name'>
                                          <span>{{monodrug.code}}</span>
                                       </div>
                                       <div class="col-auto px-1">
                                          {{monodrug.dose}}
                                       </div>
                                    </div>
                                 </div>
                              </td>
                              <!-- <td class="border py-0 table-light text-center">V</td> -->
                              <td class="border p-0 table-light text-center">
                                 <button type="button" 
                                       :tabindex="3" 
                                       class="btn btn-sm p-0" 
                                       @click="deletePrescribed(index)"
                                       >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                                       <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                                    </svg>
                                 </button>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                     <!--
                     {{prescribedDrugs}} <br>
                     {{code310Drugs}}
                     -->
                     <div v-for="(key, index) in code310Drugs" :key="index" class="fs-14">
                        {{index}} - {{key.name}} - Dosis: {{key.dose}}
                     </div>
                  </div>
                  <div v-if="prescribedDrugs.length == 0" class="row text-end fs-14">
                     <i class="pe-0 tx-cl-red">Ingresar al menos una monodroga!</i>
                  </div>
                  <!--
                  -->
               </template>

               <!-- third data prescription rest,... -->
               <template v-if="currentStep === 2">

                  <div class="row justify-content-between">
                     <div class="col-12 p-0 m-0">
                        <textarea-field :fieldData="v310Cnf.doctorsObservations" :tabindex="2" :id="'first'"/>
                     </div>
                     <div class=" col-12 col-md-6 p-0 m-0">
                        <common-field 
                           :fieldData="v310Cnf.prescriptionDate" 
                           :tabindex="3"
                           :readonly="readonly"
                           />
                     </div>
                     <div class=" col-12 col-md-5 p-0 m-0">
                        <common-field :fieldData="v310Cnf.medicalRegistration" :tabindex="4"/>
                     </div>
                     <div class="col-12 p-0 m-0">
                        <textarea-field :fieldData="v310Cnf.voucherObservations" :tabindex="5"/>
                     </div>
                  </div>

                  <!--
                  -->
               </template>
            
               <!-- fourth data voucher,... -->
               <template v-if="currentStep === 3 && !showV310">
                  <voucher-310-pdf :pdfData="pdfData" />
                  <!--
                  {{ dataVoucher }}
                  <br/>
                  <br/>
                  {{dataAffil}}
                  -->
               </template>
            
               <!-- fifth pdf voucher,... -->
               <template v-if="showV310">
                  <voucher-310-pdf :pdfData="pdfData" />
               </template>
               
               <div class=" row border-top mt-3">
                  <div v-if="!showV310" class="col-12 p-0 m-0">
                     <textarea-field :fieldData="v310Cnf.internalObservations" :tabindex="currentLastTabIndex"/>
                  </div>
               </div>
               
               <div class="row p-0 justify-content-between">
                  <div class="d-flex justify-content-start pt-2 px-0 col-2">
                     <user-circle :circleUser="myCircle" /> <!--  class="col-2 mt-2"/> -->
                     <!--
                     <button v-if=" oDataFromCard.cardId > 0 "
                     <button v-if=" false "
                     -->
                     <button v-if=" false "
                           type="button" 
                           :tabindex="currentLastTabIndex + 1" 
                           class="btn btn-sm ms-1" 
                           @click="viewAttachs()"
                           >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-paperclip tx-cl-white" viewBox="0 0 16 16">
                           <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0z"/>
                        </svg>
                     </button>
                  </div>
                  <div class="d-flex justify-content-end pt-2 px-0 col-10">
                     <button v-if="currentStep != 0 && !showV310"
                           type="button" 
                           :tabindex="currentLastTabIndex + 2" 
                           class="btn btn-outline-light btn-sm me-2" 
                           @click="prevStep(values)"
                           >
                        Anterior
                     </button>
                     <button v-if="currentStep != lastStep && !showV310"
                           type="submit" 
                           :tabindex="currentLastTabIndex + 3" 
                           class="btn btn-outline-light btn-sm me-2"
                           >
                        Siguiente
                     </button>
                     <button v-if="currentStep == lastStep && !showV310"
                           type="submit" 
                           :tabindex="2" 
                           :id="'first'" 
                           class="btn btn-outline-light btn-sm me-2"
                           @click="updateVoucher()"
                           >
                        Guardar
                     </button>
                     <button v-if="showV310"
                           type="button" 
                           :tabindex="2" 
                           :id="'first'" 
                           class="btn btn-outline-light btn-sm me-2"
                           @click="generatePDF( false )"
                           >
                        Descargar
                     </button>
                     <button type="button" 
                           :tabindex="currentLastTabIndex + 4" 
                           class="btn btn-outline-light btn-sm" 
                           @click="beforeClose()"
                           id="lastima"
                           >
                        Salir
                     </button>
                     <div :tabindex="currentLastTabIndex + 5" onfocus="document.getElementById('first').focus()"></div>
                  </div>
               </div>
               <!--
                     <button v-if="currentStep == lastStep"
                           type="submit" 
                           :tabindex="currentLastTabIndex + 2" 
                           class="btn btn-outline-light btn-sm me-2"
                           >
                        Guardar
                     </button>
               -->
               <!-- 
               <pre>{{ dataVoucher }}</pre>
               <pre>{{ dataFields }}</pre>
               <pre>{{ oDataFromCard }}</pre>
               <pre>{{ dataFromCard }}</pre>
               <pre>{{ pdfData }}</pre>
               <pre>{{ values }}</pre>
               <pre>{{ dataVoucher }}</pre>
               -- 
               <pre>{{ vouchers }}</pre>
               <pre>{{ values }}</pre>
               <pre>{{ dataVoucher }}</pre>
               <pre>{{ prescribedDrugs }}</pre>
               <pre>{{ cmpRequestDate }}</pre>
               <pre>{{ upWizardDrugs }}</pre>
               <pre>{{ chronicDiseases }}</pre>
               <pre>{{ code310Drugs }}</pre>
               <pre>{{ onBlurCuit }}</pre>
         <div class="accordion" id="accordionExample">
            {{attachs}}
            attachFolder + attachs.value[event.to].id + "_" + attachs.value[event.to].name
                           <vuePdfEmbed :source="pdfUrl" />
                           <vuePdfEmbed :source="'/WorkSpace/Content/Attach/975_Mail-NTF-00000819-27167811057.pdf'" />
                  -->
            </Form>
         </div>
         <div v-if="attachs.length > 0" class="border rounded mt-2 view-attachs">
            <div v-show="showAttList">
               <div class="list-group">
                  <button v-for="(attach, index) in attachs" :key="index"
                     type="button" 
                     class="list-group-item list-group-item-action" 
                     :disabled="!(isImage(attach.name) || extension(attach.name).toUpperCase()=='PDF')"
                     @click="showAttachFile(index)"
                  >
                     {{attach.name}}
                  </button>
               </div>
            </div>
            <div v-show="showAttFile" @click="showAttachList()" class="text-center hover-click">
               <b>{{attFileName}}</b>
               <vuePdfEmbed v-if="extension(attFileName).toUpperCase()=='PDF'" :source="pdfUrl" :height="5000" />
               <img v-if="isImage(attFileName)" :src="pdfUrl" alt="" class="img-zoom"/>
            </div>
            <div v-if="false">
            <div v-for="(attach, index) in attachs" :key="index" class="accordion-item">
               <h2 class="accordion-header">
                  <button class="accordion-button collapsed p-2" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse' + index" aria-expanded="false" :aria-controls="'collapse' + index">
                     {{attach.name}}
                  </button>
               </h2>
               <div :id="'collapse' + index" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                     <div v-if="isImage(attach.name)">
                        <img class="of-x"
                           :src="attachFolder+`${attach.id}_${attach.name}`" 
                           alt=""
                        >
                     </div>
                     <div v-else>
                        <div v-if="extension(attach.name).toUpperCase()=='PDF'">
                           <vuePdfEmbed :source="'/WorkSpace/Content/Attach/975_Mail-NTF-00000819-27167811057.pdf'" />
                        </div>
                        <div v-else class="tx-cl-dark pt-1">
                           <b>No existe ninguna visualización previa disponible para este adjunto.</b>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
         </div>
      </div>
   </vue-final-modal>
   <up-wizard-drugs v-if="upWizardDrugs" 
      :chronics="chronicDiseases"
      :v310drugs="code310Drugs"
      :cuil=" dataAffil.id "
      @cancel="upWizardDrugs = false"
      @upDrugs="(val) => addDrugs(val)"
      @freeDrug="(val) => up310Drugs(val)"
      />
   <search-affiliate v-if="searchAffil"
      @cancel="searchAffil = false"
      @cuil="(val) => upCuil(val)"
      />
   <history-v-310 v-if="historyv310"
      :history="vouchers"
      @cancel="historyv310 = false"
      @annulComplObj="(val) => addAnnulCompl( val )"
      />
</template>

<script>

//import { ref, onMounted, watch, watchEffect, nextTick, getCurrentInstance } from 'vue';
//import { Form, Field, ErrorMessage } from 'vee-validate';
//import { string, date, object } from "yup";

import { VueFinalModal } from 'vue-final-modal'
import { ref, computed, nextTick } from 'vue';
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { Form, defineRule } from 'vee-validate';
import * as yup from 'yup';
import moment from 'moment';
import html2pdf from 'html2pdf.js';
import vuePdfEmbed from 'vue-pdf-embed'

import WspService from '../../workSpace/workSpace.service';
import V310Service from '../voucher310.service';
import AnalyService from '../../analytics/analytics.service';

import AffiliateData from '../../analytics/components/affiliate/AffiliateDataShow.vue';
import CommonField from './CommonField.vue';
import SearchAffiliate from '../../analytics/components/affiliate/SearchAffiliate.vue';
import SelectField from './SelectField.vue';
import SpecialButtonField from './SpecialButtonField.vue';
import TextareaField from './TextareaField.vue';
import UpWizardDrugs from './UpWizardDrugs.vue';
import UserCircle from '../../../components/UserCircle.vue';
import Voucher310Pdf from './Voucher310Pdf.vue';
import HistoryV310 from './HistoryV310.vue';

export default {

   components: {
      AffiliateData,
      CommonField,
      Form,
      HistoryV310,
      SearchAffiliate,
      SelectField,
      SpecialButtonField,
      TextareaField,
      UserCircle,
      UpWizardDrugs,
      Voucher310Pdf,
      VueFinalModal,
      vuePdfEmbed
   },

   props: {
      dataFromCard: {
         type: String,
         default: '{"cardId":0}'
      }
   },

   emits: [ 'cancel' ],  //, 'upDrugs' ],

   setup( props, { emit }) {

      defineRule('dfrValidCuil', value => {

         console.log(value)
         if ( validCuil.value && onBlurCuit.value) {
            return true
         }

         validCuil.value = false
         annulComplValues.value = { annulCompl: 0 }
         console.log(value)

         if ( value === undefined ) { return 'Dato requerido!' }
         if ( isNaN( value ) ) { return 'Debe ser un número!' }
         if ( value < 20000000000 ) { return 'Número de CUIL inválido!' }
         if ( value > 40000000000 ) { return 'Número de CUIL inválido!' }
         if ( parseInt( value ) != value ) { return 'Debe ser un número entero!' }
         
         if ( oDataFromCard.value.cardId > 0 ) {
            if ( !oDataFromCard.value.title.includes( value.toString() ) ) {
               return 'CUIL distinto al de la tarjeta!'
            }
         } 

         return dfrValidCuil( value )
      });

      const store = useStore()
      const attachFolder = process.env.VUE_APP_BASE_CNTT_ATT_FOLDER

      const currentUserId = computed(() => {
         return store.state.auth.user.id;
      })
      const myCircle = ref({})

      const v310Modal = ref(true)
      const currentStep = ref(0);
      const lastStep = 3

      const upWizardDrugs = ref(false)
      const showAffilData = ref(false)
      const validCuil = ref(false)
      const onBlurCuit = ref(false)
      const dataAffil = ref({})
      const searchAffil = ref(false)
      const newCuilValue = ref('')
      const showV310 = ref(false)

      const prescribedDrugs = ref([])
      const dataVoucher = ref({
         //prescribedDrugs: prescribedDrugs.value
      })
      const pdfData = ref({})
      const vouchers = ref([])
      const historyv310 = ref(false)

      const dataFields = ref({})

      const v310Schema = [
         //yup.object({
         {
            cuil: 'dfrValidCuil',
            requestDate: yup.date()
               .required('Fecha Requerida!')
               .typeError( 'Fecha Inválida!' )
               .max(moment(new Date()).format('YYYY-MM-DD'), 'Fecha mayor al día de hoy!')
               .min(moment(new Date()).subtract(6, 'month').format('YYYY-MM-DD'),
                     'La Fecha debe ser posterior al '+moment(new Date()).subtract(6, 'month').format('DD-MM-YYYY')+'!'),
            tramitNumber: yup.string(),   //.required("¡Se requiere Nro!"),
            phone: yup.string(),
            specialty: yup.string().required("Dato requerido!"),
            internalObservations: yup.string()
         },

         {
            prescribedDrugs() {
               
               if ( prescribedDrugs.value.length == 0 ) {
                  return false
                  //return "Ingresar al menos una droga!"
               }

               return true
            }
         },

         /*
         yup.object({
            prescribedDrugs: yup.array().min(1, "Ingresar al menos una droga!")
         }),

         yup.object({
            disease: yup.string().required("Dato requerido!")
         }),
         */
         {
            doctorsObservations: yup.string(),
            prescriptionDate(value) {
               
               if ( !(value && value.trim()) ) {
                  return 'Fecha Requerida!';
               }
               
               if ( value > cmpRequestDate.value ) {
                  return 'Fecha mayor a la de solicitud!'
               }

               let minDate = moment(new Date()).subtract(6, 'months').format('YYYY-MM-DD')
               if ( value < minDate ) {
                  return 'La Fecha debe ser posterior al ' + minDate + '!'
               }

               return true;
            },
            medicalRegistration: yup.number()
               .typeError( 'Debe ser un numero!' )
               .moreThan( 0, 'Debe ser mayor a cero!' )
               .integer( 'Debe ser entero' ),
            voucherObservations: yup.string()
         }
         /*
         yup.object({
            prescriptionDate: yup.date()
               .required('Fecha Requerida!')
               .max(moment(cmpRequestDate), 'Fecha mayor a la de solicitud!')
               .min(moment(new Date()).subtract(6, 'months').format('YYYY-MM-DD'),
                     'La Fecha debe ser posterior al '+moment(new Date()).subtract(6, 'months').format('DD-MM-YYYY')+'!'),
            medicalRegistration: yup.string()
         })
         */
      ]
      /*
            prescriptionDate: yup.date().required('Fecha Requerida!'),
      */
      const lastTabIndex = [7, 3, 6, 3]

      const currentSchema = computed(() => {
         //console.log(currentStep.value)
         return v310Schema[currentStep.value];
      })

      const currentLastTabIndex = computed(() => {
         return lastTabIndex[currentStep.value];
      })

      const cmpRequestDate = computed(() => {
         return dataVoucher.value.requestDate
      })

      const v310Cnf = {
         cuil: {
            name: 'cuil',
            label: 'C.U.I.L.',
            type: 'text'
         },
         requestDate: {
            name: 'requestDate',
            label: 'Fecha de Solicitud',
            type: 'date'
         },
         tramitNumber: {
            name: 'tramitNumber',
            label: 'Nro de Trámite',
            type: 'text'
         },
         phone: {
            name: 'phone',
            label: 'Teléfono',
            type: 'text'
         },
         specialty: {
            name: 'specialty',
            label: 'Especialidad'
         },
         disease: {
            name: 'disease',
            label: 'Enfermedad'
         },
         doctorsObservations: {
            name: 'doctorsObservations',
            label: 'Observaciones Médico'
         },
         prescriptionDate: {
            name: 'prescriptionDate',
            label: 'Fecha Prescripción',
            type: 'date'
         },
         medicalRegistration: {
            name: 'medicalRegistration',
            label: 'Matrícula',
            type: 'text'
         },
         voucherObservations: {
            name: 'voucherObservations',
            label: 'Observaciones Voucher'
         },
         internalObservations: {
            name: 'internalObservations',
            label: 'Observaciones Internas'
         }
      }

      const specialtys = ref([])
      const chronicDiseases = ref([])
      const code310Drugs = ref( {})
      const annulComplValues = ref({ annulCompl: 0 })

      const router = useRouter()
      const oDataFromCard = ref({})
      const changeValue = ref(false)
      const readonly = ref(false)

      const attachs = ref([])
      const pdfUrl = ref('') //'/WorkSpace/Content/Attach/975_Mail-NTF-00000819-27167811057.pdf'
      const showAttList = ref(true)
      const showAttFile = ref(false)
      const attFileName = ref('')

      function addAnnulCompl( value ) {
         console.log( value )
         annulComplValues.value = value
      }

      function addDrugs(val) {
         prescribedDrugs.value.push(val)
         chronicDiseases.value[val.disease.value].disabled = true
      }

      function affilHistory( cuil ) {
         vouchers.value = []
         V310Service.findVouchers(
            {
            records: 0,
            field: "v310.prescription_date",
            order: "desc",
            pageNumber: 0,
            itemsByPage: 250,
            cuil: Number(cuil)
            }
         )
         .then(response => {
            console.log(response.data)
            if ( response.data.records == 0 ) {
               alert('No se registran Vouchers anteriores para este cuil!')
            } else {
               vouchers.value = response.data.vouchers
               nextTick(() => {
                  historyv310.value = true
               })
            }
         })
         .catch(error => {
            console.log(error);
         })
      }

      function beforeClose() {
         let lCancel = false
         if ( showV310.value ) {
            //emit('cancel')
            lCancel = true
         } else {
            let text = "Si sale se perderan los datos ingresados.";
            if (confirm(text) == true) {
               //emit('cancel')
               lCancel = true
            }
         }

         if ( lCancel ) {
            if ( oDataFromCard.value.cardId == 0 ) {
               emit('cancel')
            } else {
               //store.dispatch("wspace/setContentId", -13)
               nextTick(() => {
                  router.go(-1)
               })
            }
         }
      }

      function beforeOpen() {

         oDataFromCard.value = JSON.parse( props.dataFromCard )
         console.log('beforeOpen')
         
         if ( oDataFromCard.value.cardId > 0 ) {
            getFormValues()
         }
         v310Modal.value = true

         V310Service.findChronicDisease()
         .then(response => {
            chronicDiseases.value = [
               { value: '', name: 'Seleccione una Enfermedad', disabled: true }, ...response.data]
         })
         .catch(error => {
            console.log(error);
         })

         V310Service.findMedicalSpecialties()
         .then(response => {
            specialtys.value = [
               { value: '', name: 'Seleccione una Especialidad', disabled: true },
                ...response.data,
               { value: 98, name: 'Especialidad no Informada', disabled: false },
               { value: 99, name: 'Especialidad no Encontrada', disabled: false }
               ]
         })
         .catch(error => {
            console.log(error);
         })
      }

      function deletePrescribed(index) {
         let chronicIndex = prescribedDrugs.value[index].disease.value
         //console.log(chronicIndex)
         //console.log(chronicDiseases.value[chronicIndex].name)
         chronicDiseases.value[chronicIndex].disabled = false

         for (let key in prescribedDrugs.value[index].drugs) {
            //console.log(prescribedDrugs.value[index].drugs[key].name)
            let drugIndex = prescribedDrugs.value[index].drugs[key].code
            //code310Drugs.value['_'+drugIndex].free = true
            delete code310Drugs.value[drugIndex]
         }
         // code310Drugs[val.index].free = val.free
         prescribedDrugs.value.splice( index, 1)

      }

      function viewAttachs() {
         if ( attachs.value.length == 0 ) {
            WspService.getAttachs(0, oDataFromCard.value.cardId, false)
            .then(response => {
               console.log(response.data)
               attachs.value = response.data
               /* if (attachs.value.length > 0)
                  viewAttach.value = true */
            })
            .catch(error => {
               console.log(error);
            });
         } else {
            attachs.value = []
         }
         showAttList.value = true
         showAttFile.value = false
         attFileName.value = ''
      }

      function getFormValues() {
         WspService.getFormValues( oDataFromCard.value.cardId )
         .then(response => { 
            dataFields.value =  response.data 
            if ( dataFields.value.affiliateCuil != null ) {
               dataVoucher.value.cuil = dataFields.value.affiliateCuil
               dataVoucher.value.requestDate = dataFields.value.requestDate
               if ( dataFields.value.dateFrom != null ) {
                  dataVoucher.value.prescriptionDate = dataFields.value.dateFrom
               }
               readonly.value = true
            }
         })
         .catch(error => { console.log(error) })
         
      }

      function extension(fileName) {
         let exten = fileName.lastIndexOf(".");
         if (exten == -1) {
            return ""; // empty extension
         }
         return fileName.substring(exten+1);
      }

      function isImage(fileName) {
         let imageFileExten = ".jpg.apng.avif.gif.jpeg.jfif.pjpeg.pjp.png.svg.webp.bmp.ico.cur.tif.tiff."
         if (imageFileExten.lastIndexOf(extension(fileName.toLowerCase())) > 0) {
            return true
         }
         return false
      }

      function keepValues( values ) {
         for (let key in values) {
            dataVoucher.value[key] = values[key]
            if (values[key] == "") {
               delete dataVoucher.value[key]
            }
         }
      }

      async function nextStep(values) {
         keepValues( values )

         if (currentStep.value == lastStep) {
            console.log('Done: ', JSON.stringify(dataVoucher.value, null, 2))
            return;
         } else {
            currentStep.value++;
            if ( currentStep.value == 3 ) {
               
               /*
               let arrDiseases = []
               for ( let key in prescribedDrugs.value ) {
                  
                  let arrDrugs0 = []
                  for ( let key2 in prescribedDrugs.value[ key ].drugs ) {
                     arrDrugs0.push({
                        id: prescribedDrugs.value[ key ].drugs[key2].id,
                        code: prescribedDrugs.value[ key ].drugs[key2].code,
                        dose: prescribedDrugs.value[ key ].drugs[key2].dose
                     })
                  }

                  arrDiseases.push({ 
                     id: prescribedDrugs.value[ key ].disease.diseaseId,
                     drugs: arrDrugs0
                     })
               }
               */

               let arrDrugs = []
               for ( let key in code310Drugs.value ) {
                  arrDrugs.push( code310Drugs.value[ key ].name)
               }
               //
               let typeTime = 'M'
               let numberOf = 12
               let validUntilTime =  await findValidUntilDate( dataVoucher.value.prescriptionDate )
               console.log(JSON.stringify(validUntilTime, null, 2))
               typeTime = validUntilTime.typeTime
               numberOf = validUntilTime.numberOf
               //
               pdfData.value = {
                  //affil: { 
                     name: dataAffil.value.name, 
                     cuil: dataAffil.value.id,
                     provinceState: dataAffil.value.provinceState,
                     sex: dataAffil.value.sex,
                  //},
                  //voucher: { 
                     id: '00000000',
                     requestDate: moment(dataVoucher.value.requestDate).format('DD/MM/YYYY'),
                     prescriptionDate: moment(dataVoucher.value.prescriptionDate).format('DD/MM/YYYY'),
                     //validDate: moment(dataVoucher.value.prescriptionDate).add(6, 'months').format('DD/MM/YYYY'),
                     validDate: moment(dataVoucher.value.prescriptionDate).add(numberOf, typeTime).format('DD/MM/YYYY'),
                     requestCanceled: '',
                     voucherObservations: dataVoucher.value.voucherObservations,
                     userName: myCircle.value.name,
                     nowDate: moment(new Date()).format('DD/MM/YYYY'),
                     nowDateTime: moment(new Date()).format('DD/MM/YYYY HH:mm:ss'),
                  //},
                  drugs: arrDrugs
               }
               if ( annulComplValues.value.annulCompl > 0) {
                  pdfData.value.cancellationReason = { id: annulComplValues.value.annulCompl }
                  pdfData.value.requestCanceled = Number(annulComplValues.value.id)
               }
               console.log(pdfData.value)
            }
            nextTick(() => {
               document.getElementById('first').focus()
            })
         }
      }

      function findValidUntilDate( date ) {
         return new Promise( (resolve) => {
            WspService.findValidUntilDate( date )
            .then(response => { resolve ( response.data )})
            .catch(error => { console.log(error) })
         })
      }

      function opened() {
         WspService.getMyCircle(currentUserId.value)
         .then(response => {
            console.log(response.data)
            myCircle.value = response.data
         })
         .catch(error => {
            console.log(error);
         })

         document.getElementById('first').focus()
      }
      /*
      function pdfUrl(  ) {
         //return attachFolder + attach.id + "_" + attach.name
         return 'https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/examples/learning/helloworld.pdf'
      }
      */

      function prevStep( values ) {
         if (currentStep.value <= 0) {
            return;
         }

         keepValues( values )
         currentStep.value--;
      }

      function showAttachFile(index) {
         pdfUrl.value = attachFolder + attachs.value[index].id + "_" + attachs.value[index].name
         attFileName.value = attachs.value[index].name
         showAttList.value = false
         showAttFile.value = true
      }

      function showAttachList() {
         showAttList.value = true
         showAttFile.value = false
         attFileName.value = ''
      }

      function up310Drugs(drug) {
         console.log(drug)
         if (drug.option) {
            code310Drugs.value[drug.index] = {
               dose: drug.dose,
               name: drug.name
            }
         } else {
            delete code310Drugs.value[drug.index]
         }
      }

      function upCuil( cuil ) {
         console.log( cuil )
         //dataVoucher.value.cuil = cuil
         //console.log( dataVoucher.value.cuil )
         newCuilValue.value = cuil
         searchAffil.value = false
         changeValue.value = true
         nextTick(() => {
            //document.getElementById('resetCuil').click()
            document.getElementById('first').focus()
            changeValue.value = false
         })
      }

      function updateVoucher() {
            
         let arrDiseases = []
         for ( let key in prescribedDrugs.value ) {
            
            let arrDrugs0 = []
            for ( let key2 in prescribedDrugs.value[ key ].drugs ) {
               arrDrugs0.push({
                  id: prescribedDrugs.value[ key ].drugs[key2].id,
                  code: prescribedDrugs.value[ key ].drugs[key2].code,
                  dose: prescribedDrugs.value[ key ].drugs[key2].dose
               })
            }

            arrDiseases.push({ 
               id: prescribedDrugs.value[ key ].disease.diseaseId,
               drugs: arrDrugs0
               })
         }

         dataVoucher.value.diseases = arrDiseases
         dataVoucher.value.userId = currentUserId.value
         //dataVoucher.value.createDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
         if ( annulComplValues.value.annulCompl > 0) {
            dataVoucher.value.cancellationReasonId = annulComplValues.value.annulCompl
            dataVoucher.value.cancelAuthorization = Number(annulComplValues.value.id)
         }
         if ( oDataFromCard.value.cardId > 0 ) {
            dataVoucher.value.cardId = oDataFromCard.value.cardId
         }
         V310Service.updateVoucher(dataVoucher.value)
         .then(response => {
            let voucher310Id = response.data
            console.log(voucher310Id)
            V310Service.getVoucherPdf(voucher310Id)
            .then(response => {
               console.log(response.data)
               pdfData.value = response.data
               console.log(response.data)
               nextTick(() => {
                  if ( oDataFromCard.value.cardId > 0 ) {
                     generatePDF( true )
                  } else {
                     showV310.value = true
                  }
               })
            })
            .catch(error => {
               console.log(error);
            })

            //emiter('v310ToDo', 'findVouchers')
            //emit('closeAdd') 
         })
         .catch(error => {
            console.log(error);
         })
      }

      function upV310(v310) {
         console.log(v310)
      }

      async function dfrValidCuil( value ) {

         console.log(value)

         let promise = new Promise(( resolve ) => {
            AnalyService.affiliateExists( value )
               .then(response => {
                  resolve( response.data )
               })
               .catch(error => {
                  console.log(error);
                  return 'Error de red!'
               });
         })

         let result = await promise
         if ( result == 'N') {
            return 'No hay ningún Afiliado con este CUIL'
         }
         if ( result == 'I') {
            return 'No es un Afiliado Activo'
         }
         
         if ( !findAffilData( value ) ) {
            return 'Error de red!'
         }
         return true
      }

      async function findAffilData( value ) {

         let promise = new Promise(( resolve ) => {
            AnalyService.getAffiliateBasicData( value )
               .then(response => {
                  resolve( response.data )
               })
               .catch(error => {
                  console.log(error);
                  return false
               });
         })

         dataAffil.value = await promise
         validCuil.value = true

         return true
      }
      
      async function generatePDF( attach ) {
         //
         let result = await createPDF()
         const blob = new Blob([result], { type: 'application/pdf' })
         //let file = new File([blob], 'pepitito.pdf',  { type: 'application/pdf' })
         //let file = new File([blob], String( 'voucher310' ) + '.pdf',  { type: 'application/pdf' })
         let file = new File([blob], 
            'V310-' + pdfData.value.id + '-' + pdfData.value.cuil + '.pdf',
            { type: 'application/pdf' })
         //
         // Create a download link for the resulting PDF Blob and trigger the download
         if ( attach ) {
            //store.dispatch("wspace/setContentId", -13)
            console.log(attach)
            WspService.addAttachContent(
               oDataFromCard.value.cardId,     // contentId, 
               oDataFromCard.value.cellId,    // cellId,
               oDataFromCard.value.boardId,
               dataVoucher.value.userId,     // userId, 
               file   // attachFile
            )
            .then(response => {            
               console.log(response.data)
               showV310.value = true
               console.log("attach ok: ")
               store.dispatch("wspace/setContentId", -13)
            })
            .catch(error => {
               console.log(error);
               showV310.value = true
            });
         } else {
            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(file);
            downloadLink.download = file.name;
            downloadLink.onclick = () => downloadLink.remove();
            document.body.appendChild(downloadLink);
            downloadLink.click();
         }
         //
         //         
      }
      function createPDF() {
         return new Promise( (resolve, reject) => {
            console.log('create PDF function executed!');
            let element = document.getElementById('element-to-print');

            let opt = {
               margin: 10,
               enableLinks: false,
               image: {type: 'jpeg', quality: 0.95},
               html2canvas: {scale: 2, useCORS: true}
               //jsPDF: {format: 'a4', orientation: 'portrait'}
            };

            try {
                const blob = html2pdf().set(opt).from(element).outputPdf('blob');
                resolve(blob);
            } catch (e) {
                reject(e);
            }
         });
      }

      return {
         addAnnulCompl, addDrugs, affilHistory, annulComplValues, attachs, attachFolder, attFileName,
         beforeClose, beforeOpen,
         changeValue, cmpRequestDate, chronicDiseases, code310Drugs,
         currentLastTabIndex, currentSchema, currentStep,
         dataAffil, dataFields, dataVoucher, deletePrescribed,
         findAffilData,
         generatePDF,
         extension,
         historyv310,
         isImage,
         lastStep,
         myCircle,
         nextStep, newCuilValue,
         oDataFromCard, onBlurCuit, opened,
         pdfData, pdfUrl, prescribedDrugs, prevStep,
         readonly,
         searchAffil, showAffilData, showV310, specialtys,
         showAttFile, showAttList, showAttachFile, showAttachList,
         v310Cnf, v310Modal, v310Schema, validCuil, viewAttachs, vouchers,
         up310Drugs, upCuil, updateVoucher, upV310, upWizardDrugs
      }
   },
}
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  /*align-items: center;*/
}
::v-deep(.v310-modal-content) {
  /*
  background: #fff;
  padding: 0.75rem;
  width: auto;
  */
  position: relative;
  display: flex;
  flex-direction: column;
  top: 5%;
  min-width: 350px;
  max-width: 750px;
  max-height: 90%;
  padding: 0.00rem 0.25rem 0.25rem 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background-color: #9E9E9E ;
}
.modal__title {
  margin: 0 2rem 0 0.20rem;
  font-size: 1.25rem;
  font-weight: 450;
}
.modal__close {
  position: absolute;
  top: 0.05rem;
  right: 0.10rem;
}
/*
  margin: 0 1rem;
*/
.up-voucher {
   background-color: #9E9E9E ;
   /*
   background-color: blue ;
   background-color: #9E9E9E ;
   margin-top: 10px ;
   max-width: 500px;
   max-width: 500px;
   */
   max-height: calc(100vh - 28px);
   overflow-y: auto;
   color: white;
}
.view-attachs {
   max-height: calc(40vh - 28px);
   overflow-y: auto;
}
.tx-cl-white {
   color: white;
}
.tx-cl-red {
   color: red;
}
.tx-cl-dark {
   color: rgb(100, 100, 100);
}
.fs-14 {
   font-size: 14px;
}
.bg-contrast {
   background-color: #d2cece;
}
.border-contrast {
   border: 1px solid #d2cece;
}
.tr-drugs {
   font-size: 0.875rem;
}
td {
   height: 1.5rem;   
}
.pill {
   height: 1.5rem;   
}
.btn-h {
   font-size: 20px;
}
.hover-click:hover {
   cursor: pointer;
}
.of-x {
   max-width: 100%;
}
.img-zoom {
   height: 1000px;
}
</style>
